module.exports = __webpack_public_path__ + "img/cajarequipa.5c9fb951.jpg";